<!--footer section -->
<footer [class]="class">
  <div class="light-layout" *ngIf="newsletter">
    <div class="container">
      <section class="small-section border-section border-top-0">
        <div class="row">
          <div class="col-lg-6">
            <div class="subscribe">
              <div>
                <h4>saiba tudo antes:</h4>
                <p>
                  Acompanhe as nossas novidades inscrevendo-se em nosso boletim
                  informativo.
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <form
              class="form-inline subscribe-form"
              action="https://pixelstrap.us19.list-manage.com/subscribe/post?u=5a128856334b598b395f1fc9b&amp;id=082f74cbda"
              target="_blank"
              method="post"
            >
              <div class="form-group mx-sm-3">
                <input
                  type="email"
                  #name
                  name="EMAIL"
                  id="mce-EMAIL"
                  class="form-control"
                  placeholder="Informe seu email"
                  [formControl]="msgForm.controls['email']"
                />
                <div
                  *ngIf="
                    msgForm.controls.email.touched &&
                    msgForm.controls.email.errors?.required
                  "
                  class="text text-danger"
                >
                  E-Mail é Obrigatório!
                </div>
              </div>
              <button
                type="submit"
                class="btn btn-solid"
                (click)="enviarNewsLetter()"
              >
                Inscrever
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  </div>
  <section class="section-b-space light-layout">
    <div class="container">
      <div class="row footer-theme partition-f">
        <div class="col-lg-3 col-md-6">
          <div class="footer-title footer-mobile-title">
            <h4>about</h4>
          </div>
          <div class="footer-contant">
            <div class="footer-logo">
              <img id="themeLogo" [src]="themeLogo" alt="logo" />
            </div>
            <p id="loja">A sua loja virtual</p>
            <div class="footer-social">
              <ul id="ul">
                <li>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/profile.php?id=100090492007030"
                    ><i
                      class="fa fa-facebook"
                      style="font-size: 25px"
                      aria-hidden="true"
                    ></i
                  ></a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/monkeymoney.brasil/"
                    ><i
                      class="fa fa-instagram"
                      style="font-size: 25px"
                      aria-hidden="true"
                    ></i
                  ></a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/monkeymoneybrasil/"
                    ><i
                      class="fa fa-linkedin"
                      style="font-size: 25px"
                      aria-hidden="true"
                    ></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col offset-lg-1" style="margin-left: 0px">
          <div class="sub-title">
            <div class="footer-title">
              <h4></h4>
            </div>
            <div class="footer-contant">
              <ul>
                <li><a href="#">Home</a></li>

                <li>
                  <a [routerLink]="['/pages/aboutus/']" class="nav-link"
                    >Sobre Nós</a
                  >
                </li>
                <li>
                  <a [routerLink]="['/pages/collection/']" class="nav-link"
                    >Guia Monkey</a
                  >
                </li>
                <li>
                  <a [routerLink]="['/pages/contact/']" class="nav-link"
                    >Fale Conosco</a
                  >
                </li>
                <li>
                  <a (click)="openModal()" class="nav-link"
                    >Termos e Condições Gerais de Uso</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="sub-title">
            <div class="footer-title">
              <h4>Por que nos escolher</h4>
            </div>
            <div class="footer-contant">
              <ul>
                <li>
                  <a href="javascript:void(0)">Envio e devolução facilitada</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Segurança na sua compra </a>
                </li>
                <li>
                  <a href="javascript:void(0)"
                    >Diversidade de produtos e empresas</a
                  >
                </li>
                <li><a href="javascript:void(0)">Programa de afiliados</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="sub-title">
            <div class="footer-title">
              <h4>Fale Conosco</h4>
            </div>
            <div class="footer-contant">
              <ul class="contact-list">
                <li>
                  <i class="fa fa-map-marker"></i> Rua Milton Campos, Nº 205 -
                  Sala 206, Cidade Nobre, Ipatinga-MG
                </li>
                <li><i class="fa fa-phone"></i>Telefone: +55 31 9 9975-3052</li>
                <li>
                  <i class="fa fa-envelope-o"></i>Email:
                  <a>atendimento@monkeymoney.com.br</a>
                </li>
                <!-- <li><i class="fa fa-fax"></i>Fax: 9888889668</li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="sub-footer">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-md-6 col-sm-12">
          <div class="footer-end">
            <p>
              <i class="fa fa-copyright" aria-hidden="true"></i>
              {{ today | date : "y" }} Desenvolvido por Gerenciar Sistemas
              Corporativos
            </p>
          </div>
        </div>
        <div class="col-xl-6 col-md-6 col-sm-12">
          <div class="payment-card-bottom">
            <ul>
              <li>
                <a><img src="assets/images/icon/visa.png" alt="" /></a>
              </li>
              <li>
                <a><img src="assets/images/icon/mastercard.png" alt="" /></a>
              </li>
              <li>
                <a><img src="assets/images/icon/paypal.png" alt="" /></a>
              </li>
              <li>
                <a
                  ><img src="assets/images/icon/american-express.png" alt=""
                /></a>
              </li>
              <li>
                <a><img src="assets/images/icon/discover.png" alt="" /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
<!--footer section end -->
